import newsUserStatusReducer from './news-user-stats.reducer';

export default newsUserStatusReducer;
